import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/i18n/locales/en.json";
import it from "@/i18n/locales/it.json";

// To add a new language: add a locale JSON here and to SUPPORTED_LANGUAGES.
// No component changes required.
export const resources = {
  en: { translation: en },
  it: { translation: it },
};

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    nonExplicitSupportedLngs: true, // it-IT -> it
    load: "languageOnly",
    interpolation: { escapeValue: false },
    returnObjects: true,
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "orkeva_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
